import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Auth } from "aws-amplify";
import {
  useNotify,
  useTranslate,
  useAuthState,
  useRedirect,
} from "react-admin";

// Layout
import { AuthLayout } from "../../layouts/AuthLayout";

import {
  Input,
  Button,
  CircularProgress,
  Typography,
  Box,
  makeStyles,
} from "@material-ui/core";
import { LoaderApp } from "../../components/layout/LoaderApp";

const useStyles = makeStyles((theme) => ({
  title: {
    color: "#2D4050",
    fontWeight: "bold",
    marginBottom: 5,
    textAlign: "center",
  },
  contentText: {
    color: "#888888",
    fontWeight: "normal",
    fontSize: 16,
    margin: 0,
    marginBottom: 25,
    textAlign: "center",
  },
}));

export default function ChangePassword() {
  const classes = useStyles();
  const translate = useTranslate();
  const [btnSubmit, setBtnSubmit] = useState(true);
  const { register, handleSubmit, watch } = useForm();
  const notify = useNotify();
  const { authenticated, loaded } = useAuthState();
  const redirect = useRedirect();

  const handleChangePassword = (data, event) => {
    setBtnSubmit("loading");
    if (data.newPassword !== data.conPassword) {
      setBtnSubmit(true);
      notify("ra.notification.password_not_same_error", "warning");
    } else {
      Auth.forgotPasswordSubmit(
        window.localStorage.getItem("usernameForgotPass"),
        data.code,
        data.newPassword
      )
        .then((data) => {
          window.localStorage.removeItem("usernameForgotPass");
          notify("ra.notification.password_changed_success", "success");
          setTimeout(() => redirect("/login"), 500);
          event.target.reset();
        })
        .catch((err) => {
          setBtnSubmit(true);
          event.target.reset();
          notify("ra.notification.invalid_code_error", "warning", 0.1);
        });
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => loaded && authenticated && redirect("/"), [loaded]);

  return (
    <>
      {
        btnSubmit === "loading" && (
          <LoaderApp />
        )
      }
      <AuthLayout>
        <form
          style={{ width: "95%", maxWidth: 410 }}
          onSubmit={handleSubmit(handleChangePassword)}
        >
          <Typography variant="h5" className={classes.title}>
            {translate("ra.auth.title")}
          </Typography>
          <p className={classes.contentText}>
            {translate("ra.auth.description")}
          </p>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridGap="22px"
            width="100%"
            margin="0 auto"
            maxWidth="410px"
          >
            <Input
              fullWidth
              placeholder={translate("ra.auth.verificationCodeField")}
              type="text"
              style={{ padding: "22px 28px" }}
              {...register("code", { required: true })}
              disableUnderline={true}
              autoComplete='new-password'
              required={true}
            />
            <Input
              fullWidth
              placeholder={translate("ra.auth.newPasswordField")}
              type="password"
              style={{ padding: "22px 28px" }}
              {...register("newPassword", { required: true })}
              disableUnderline={true}
              autoComplete='new-password'
              required={true}
            />
            <Input
              fullWidth
              placeholder={translate("ra.auth.newPasswordConfirmField")}
              type="password"
              style={{ padding: "22px 28px" }}
              {...register("conPassword", { required: true })}
              disableUnderline={true}
              autoComplete='new-password'
              required={true}
            />
            <Button
              fullWidth
              type="submit"
              variant={btnSubmit === "loading" ? "outlined" : "contained"}
              color="primary"
              style={{ margin: 55, marginBottom: 16 }}
              size="large"
              disabled={
                watch("conPassword") === undefined || watch("conPassword") === ""
                  ? true
                  : false
              }
            >
              {btnSubmit === "loading" ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                translate("ra.action.newPassword")
              )}
            </Button>
            <Link
              to="/reset-password"
              style={{ width: "100%", textDecoration: "none" }}
            >
              <Button fullWidth variant="outlined" color="inherit" size="large">
                {translate("ra.action.goBack")}
              </Button>
            </Link>
          </Box>
        </form>
      </AuthLayout>
    </>

  );
}
